export default function BulkDeleteAssetsConfirmDialogController(
  $q,
  $rootScope,
  $scope,
  alerts,
  assetDataService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleConfirmDelete = _handleConfirmDelete;

  /** *********************************************
   * Event Handlers
   */

  function _handleCloseDialog($event) {
    _closeDialog($event);
  }

  function _handleConfirmDelete($event) {
    loaderService.showViewLoader = true;
    const idList = {};
    idList.ids = vm.assets;
    return assetDataService.bulkDeleteAssets(idList).then(() => {
      alerts.success('All assets were successfully deleted.');      
      if (vm.updateCallBack) {
        vm.updateCallBack();
      }
      _closeDialog($event);
    }).catch(() => {
      alerts.error('An error occurred while deleting all assets.');
    }).finally(() => {
      loaderService.showViewLoader = false;
    });
  }

  /** *********************************************
   * Private Functions
   */

  function _closeDialog() {
    return ssDialogService.hide(ssDialogService.dialogs.assetAdmin.bulkDeleteAssetsConfirmDialog);
  }
}

BulkDeleteAssetsConfirmDialogController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  'alerts',
  'assetDataService',
  'loaderService',
  'ssDialogService'
];
